import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e147262"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "kpi-cards" }
const _hoisted_3 = { class: "kpi-content kpi-content--new-design" }
const _hoisted_4 = { class: "kpi-left-section" }
const _hoisted_5 = { class: "kpi-main-number" }
const _hoisted_6 = { class: "kpi-number" }
const _hoisted_7 = { class: "kpi-unit" }
const _hoisted_8 = { class: "kpi-label" }
const _hoisted_9 = { class: "kpi-right-section" }
const _hoisted_10 = { class: "kpi-chart-wrapper" }
const _hoisted_11 = {
  ref: "totalDeviceChart",
  class: "kpi-pie-chart"
}
const _hoisted_12 = { class: "kpi-content kpi-content--new-design" }
const _hoisted_13 = { class: "kpi-left-section" }
const _hoisted_14 = { class: "kpi-main-number" }
const _hoisted_15 = { class: "kpi-number" }
const _hoisted_16 = { class: "kpi-unit" }
const _hoisted_17 = { class: "kpi-label" }
const _hoisted_18 = { class: "kpi-right-section" }
const _hoisted_19 = { class: "kpi-chart-wrapper" }
const _hoisted_20 = {
  ref: "onlineDeviceChart",
  class: "kpi-pie-chart"
}
const _hoisted_21 = { class: "kpi-content" }
const _hoisted_22 = { class: "kpi-info kpi-info--with-chart" }
const _hoisted_23 = { class: "kpi-details" }
const _hoisted_24 = { class: "kpi-label" }
const _hoisted_25 = { class: "kpi-sub-info" }
const _hoisted_26 = { class: "kpi-sub-number" }
const _hoisted_27 = { class: "kpi-sub-number" }
const _hoisted_28 = { class: "kpi-sub-number" }
const _hoisted_29 = { class: "kpi-chart" }
const _hoisted_30 = { class: "kpi-total kpi-total--left" }
const _hoisted_31 = {
  ref: "totalCleanAreaChart",
  class: "kpi-pie-chart"
}
const _hoisted_32 = { class: "kpi-content" }
const _hoisted_33 = { class: "kpi-info kpi-info--with-chart" }
const _hoisted_34 = { class: "kpi-details" }
const _hoisted_35 = { class: "kpi-label" }
const _hoisted_36 = { class: "kpi-sub-info" }
const _hoisted_37 = { class: "kpi-sub-number" }
const _hoisted_38 = { class: "kpi-sub-number" }
const _hoisted_39 = { class: "kpi-sub-number" }
const _hoisted_40 = { class: "kpi-chart" }
const _hoisted_41 = { class: "kpi-total" }
const _hoisted_42 = {
  ref: "totalCleanTimeChart",
  class: "kpi-pie-chart"
}
const _hoisted_43 = { class: "kpi-cards energy-cards" }
const _hoisted_44 = { class: "chart-header" }
const _hoisted_45 = { class: "time-selector" }
const _hoisted_46 = { class: "time-chart" }
const _hoisted_47 = {
  ref: "timeChart",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_48 = { class: "chart-header" }
const _hoisted_49 = { class: "time-selector" }
const _hoisted_50 = { class: "area-chart" }
const _hoisted_51 = {
  ref: "areaChart",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_52 = { class: "statistics-charts-section" }
const _hoisted_53 = { class: "chart-header" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任务数据统计", -1))
const _hoisted_55 = { class: "task-data-filter" }
const _hoisted_56 = { class: "task-data-body" }
const _hoisted_57 = { class: "task-summary-pane" }
const _hoisted_58 = {
  class: "task-summary-chart",
  ref: "taskSummaryChart"
}
const _hoisted_59 = { class: "task-summary-legend" }
const _hoisted_60 = { class: "legend-item success" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-dot" }, null, -1))
const _hoisted_62 = { class: "legend-info" }
const _hoisted_63 = { class: "legend-label" }
const _hoisted_64 = { class: "legend-item abnormal" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-dot" }, null, -1))
const _hoisted_66 = { class: "legend-info" }
const _hoisted_67 = { class: "legend-label" }
const _hoisted_68 = { class: "task-reason-pane" }
const _hoisted_69 = {
  class: "task-reason-chart",
  ref: "taskReasonOverviewChart"
}
const _hoisted_70 = { class: "energy-cards" }
const _hoisted_71 = { class: "energy-card" }
const _hoisted_72 = { class: "energy-summary" }
const _hoisted_73 = { class: "summary-item" }
const _hoisted_74 = { class: "summary-label" }
const _hoisted_75 = { class: "summary-number" }
const _hoisted_76 = { class: "summary-item" }
const _hoisted_77 = { class: "summary-label" }
const _hoisted_78 = { class: "summary-number" }
const _hoisted_79 = { class: "energy-chart" }
const _hoisted_80 = {
  ref: "energyUsageBarChart",
  class: "energy-bar-chart"
}
const _hoisted_81 = { class: "chart-header efficiency-chart-header" }
const _hoisted_82 = { class: "efficiency-filters" }
const _hoisted_83 = { class: "task-data-filter" }
const _hoisted_84 = { class: "time-selector" }
const _hoisted_85 = { class: "efficiency-chart" }
const _hoisted_86 = {
  ref: "efficiencyChart",
  style: {"width":"100%","height":"300px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "kpi-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.totalDeviceCount), 1),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t("vehicles")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t("totalDevices")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, null, 512)
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "kpi-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.totalOnlineCount), 1),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t("vehicles")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t("onlineDevices")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, null, 512)
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "kpi-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.t("cleaningArea")) + " (m²)", 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("span", null, [
                            _createTextVNode("SC50: "),
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.formatNumber(_ctx.cleanInfo.sc50.total_clean_area, 2)), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _createTextVNode("SC80: "),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.formatNumber(_ctx.cleanInfo.sc80.total_clean_area, 2)), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _createTextVNode("MIX1: "),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.formatNumber(_ctx.cleanInfo.mix1.total_clean_area, 2)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.formatNumber(_ctx.totalCleanArea, 2)), 1),
                        _createElementVNode("div", _hoisted_31, null, 512)
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "kpi-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.t("cleaningtime")) + " (h)", 1),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("span", null, [
                            _createTextVNode("SC50: "),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.formatNumber(_ctx.cleanInfo.sc50.total_clean_time, 2)), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _createTextVNode("SC80: "),
                            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.formatNumber(_ctx.cleanInfo.sc80.total_clean_time, 2)), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _createTextVNode("MIX1: "),
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.formatNumber(_ctx.cleanInfo.mix1.total_clean_time, 2)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.formatNumber(_ctx.totalCleanTime, 2)), 1),
                        _createElementVNode("div", _hoisted_42, null, 512)
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "chart-card half-height-card" }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("operatingCleaningTime")), 1),
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_el_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: _ctx.timeTimeRange === 7 ? 'primary' : '',
                            size: "small",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTimeTimeRange(7)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("days7")), 1)
                            ]),
                            _: 1
                          }, 8, ["type"]),
                          _createVNode(_component_el_button, {
                            type: _ctx.timeTimeRange === 30 ? 'primary' : '',
                            size: "small",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTimeTimeRange(30)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("days30")), 1)
                            ]),
                            _: 1
                          }, 8, ["type"]),
                          _createVNode(_component_el_button, {
                            type: _ctx.timeTimeRange === 90 ? 'primary' : '',
                            size: "small",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTimeTimeRange(90)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("days90")), 1)
                            ]),
                            _: 1
                          }, 8, ["type"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, null, 512)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "chart-card half-height-card" }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("operatingCleaningArea")), 1),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_el_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: _ctx.areaTimeRange === 7 ? 'primary' : '',
                            size: "small",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeAreaTimeRange(7)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("days7")), 1)
                            ]),
                            _: 1
                          }, 8, ["type"]),
                          _createVNode(_component_el_button, {
                            type: _ctx.areaTimeRange === 30 ? 'primary' : '',
                            size: "small",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeAreaTimeRange(30)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("days30")), 1)
                            ]),
                            _: 1
                          }, 8, ["type"]),
                          _createVNode(_component_el_button, {
                            type: _ctx.areaTimeRange === 90 ? 'primary' : '',
                            size: "small",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeAreaTimeRange(90)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("days90")), 1)
                            ]),
                            _: 1
                          }, 8, ["type"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, null, 512)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createVNode(_component_el_row, {
        gutter: 20,
        style: {"margin-bottom":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "chart-card half-height-card task-data-card" }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_el_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: _ctx.taskStatsFilter === 'all' ? 'primary' : '',
                            size: "small",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeTaskStatsFilter('all')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("whole")), 1)
                            ]),
                            _: 1
                          }, 8, ["type"]),
                          _createVNode(_component_el_button, {
                            type: _ctx.taskStatsFilter === 'sc50' ? 'primary' : '',
                            size: "small",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeTaskStatsFilter('sc50')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" SC50 ")
                            ]),
                            _: 1
                          }, 8, ["type"]),
                          _createVNode(_component_el_button, {
                            type: _ctx.taskStatsFilter === 'sc80' ? 'primary' : '',
                            size: "small",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeTaskStatsFilter('sc80')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" SC80 ")
                            ]),
                            _: 1
                          }, 8, ["type"]),
                          _createVNode(_component_el_button, {
                            type: _ctx.taskStatsFilter === 'mix1' ? 'primary' : '',
                            size: "small",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeTaskStatsFilter('mix1')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" MIX1 ")
                            ]),
                            _: 1
                          }, 8, ["type"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, null, 512),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.t("tasksuccesscount")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.t("taskabnormalcount")), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, null, 512)
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_70, [
        _createVNode(_component_el_row, {
          gutter: 20,
          style: {"margin-bottom":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, { class: "kpi-card energy-bar-card" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.t("waterconsumption")) + " (L)", 1),
                          _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.formatNumber(_ctx.totalWaterUsage, 2)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.t("powerconsumption")) + " (kWh)", 1),
                          _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.formatNumber(_ctx.totalPowerConsumption, 2)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, null, 512)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, { class: "chart-card" }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("cleaningEfficiencyStatistics")), 1),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createVNode(_component_el_button_group, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: _ctx.efficiencyFilter === 'all' ? 'primary' : '',
                                size: "small",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeEfficiencyFilter('all')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("whole")), 1)
                                ]),
                                _: 1
                              }, 8, ["type"]),
                              _createVNode(_component_el_button, {
                                type: _ctx.efficiencyFilter === 'sc50' ? 'primary' : '',
                                size: "small",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeEfficiencyFilter('sc50')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" SC50 ")
                                ]),
                                _: 1
                              }, 8, ["type"]),
                              _createVNode(_component_el_button, {
                                type: _ctx.efficiencyFilter === 'sc80' ? 'primary' : '',
                                size: "small",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeEfficiencyFilter('sc80')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" SC80 ")
                                ]),
                                _: 1
                              }, 8, ["type"]),
                              _createVNode(_component_el_button, {
                                type: _ctx.efficiencyFilter === 'mix1' ? 'primary' : '',
                                size: "small",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeEfficiencyFilter('mix1')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" MIX1 ")
                                ]),
                                _: 1
                              }, 8, ["type"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        _createVNode(_component_el_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: _ctx.efficiencyTimeRange === 7 ? 'primary' : '',
                              size: "small",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeEfficiencyTimeRange(7)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("days7")), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]),
                            _createVNode(_component_el_button, {
                              type: _ctx.efficiencyTimeRange === 30 ? 'primary' : '',
                              size: "small",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.changeEfficiencyTimeRange(30)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("days30")), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]),
                            _createVNode(_component_el_button, {
                              type: _ctx.efficiencyTimeRange === 90 ? 'primary' : '',
                              size: "small",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changeEfficiencyTimeRange(90)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("days90")), 1)
                              ]),
                              _: 1
                            }, 8, ["type"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, null, 512)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}